import React, { useState, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { validateMemberPassword } from '../utils/memberPasswordPolicy';
import './ComunidadPage.css';
import './MemberResetPasswordPage.css';

const API_BASE = process.env.REACT_APP_API_URL || '/api';

const MemberResetPasswordPage = () => {
  const { t } = useTranslation();
  const [token, setToken] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const q = new URLSearchParams(window.location.search);
    const raw = q.get('token');
    setToken(raw || '');
  }, []);

  const validation = useMemo(() => validateMemberPassword(password), [password]);

  const goLogin = () => {
    window.history.pushState({}, '', '/comunidad/ingresar');
    window.dispatchEvent(new PopStateEvent('popstate'));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!token) {
      setError(t('comunidadPanel.resetInvalidLink'));
      return;
    }
    if (password !== confirm) {
      setError(t('comunidadPanel.passwordMismatch'));
      return;
    }
    if (!validation.ok) {
      setError(t('comunidadPanel.passwordPolicyError'));
      return;
    }
    setLoading(true);
    try {
      const res = await fetch(`${API_BASE}/auth/member-reset-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, new_password: password })
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok || !data.success) {
        setError(data.message || t('comunidadPanel.resetError'));
        return;
      }
      setSuccess(true);
    } catch (err) {
      setError(t('comunidadPanel.connectionError'));
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="comunidad-page">
        <div className="comunidad-card member-reset-card">
          <div className="comunidad-brand">
            <p className="comunidad-kicker">{t('comunidadPanel.kicker')}</p>
            <h1>{t('comunidadPanel.resetDoneTitle')}</h1>
            <p className="comunidad-lead">{t('comunidadPanel.resetDoneLead')}</p>
          </div>
          <button type="button" className="comunidad-btn-primary" onClick={goLogin}>
            {t('comunidadPanel.backToLogin')}
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="comunidad-page">
      <div className="comunidad-card member-reset-card">
        <div className="comunidad-brand">
          <p className="comunidad-kicker">{t('comunidadPanel.kicker')}</p>
          <h1>{t('comunidadPanel.resetTitle')}</h1>
          <p className="comunidad-lead">{t('comunidadPanel.resetLead')}</p>
        </div>

        {!token && (
          <div className="comunidad-error" role="alert">{t('comunidadPanel.resetInvalidLink')}</div>
        )}

        <form onSubmit={handleSubmit} className="comunidad-form">
          {error && <div className="comunidad-error" role="alert">{error}</div>}
          <label htmlFor="np1">{t('comunidadPanel.newPassword')}</label>
          <input
            id="np1"
            type="password"
            autoComplete="new-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            disabled={!token}
          />
          <label htmlFor="np2">{t('comunidadPanel.confirmPassword')}</label>
          <input
            id="np2"
            type="password"
            autoComplete="new-password"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            disabled={!token}
          />
          <ul className="member-pw-rules" aria-live="polite">
            <li className={validation.rules.length ? 'ok' : ''}>{t('comunidadPanel.ruleLength')}</li>
            <li className={validation.rules.lower ? 'ok' : ''}>{t('comunidadPanel.ruleLower')}</li>
            <li className={validation.rules.upper ? 'ok' : ''}>{t('comunidadPanel.ruleUpper')}</li>
            <li className={validation.rules.digit ? 'ok' : ''}>{t('comunidadPanel.ruleDigit')}</li>
            <li className={validation.rules.special ? 'ok' : ''}>{t('comunidadPanel.ruleSpecial')}</li>
          </ul>
          <button type="submit" className="comunidad-btn-primary" disabled={loading || !token}>
            {loading ? t('comunidadPanel.saving') : t('comunidadPanel.resetCta')}
          </button>
          <p className="comunidad-form-footer">
            <button type="button" className="comunidad-inline-link" onClick={goLogin}>
              {t('comunidadPanel.rememberPassword')}
            </button>
          </p>
        </form>
      </div>
    </div>
  );
};

export default MemberResetPasswordPage;
